import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { perfil } from 'src/app/models/perfil';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-edit-disciplina-user',
  templateUrl: './edit-disciplina-user.component.html',
  styleUrls: ['./edit-disciplina-user.component.scss'],
})
export class EditDisciplinaUserComponent implements OnInit {
  public documentos: any;
  public perfiles: perfil[];
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;
  public lstDisciplinas: any;

  constructor(
    public disciplinaSvc: DisciplinaService,
    public usrSvc: UserService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditDisciplinaUserComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);
  }

  ngOnInit(): void {
    this.inicarFormulario();
  }

  inicarFormulario() {
    this.registerForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      disciplinaId: new UntypedFormControl('', Validators.required),
    });

    this.disciplinaSvc.getDisciplinasDropdown().subscribe((disLst) => {
      console.log(disLst);
      this.lstDisciplinas = disLst;
      this.registerForm.get('id')?.setValue(this.dataInput.id);
      this.registerForm
        .get('disciplinaId')
        ?.setValue(this.dataInput.disciplinaId);
    });
  }

  guardar() {
    console.log('guardar cambios disciplina');
    console.log(this.registerForm.value);

    this.usrSvc.editarDisciplinaUsuario(this.registerForm.value).subscribe((res) => {
      console.log('resultado EditarDisciplina: ', res);
      if (res) {
        this.alertify.success('Disciplina actualizada correctamente');
        this.dialogRef.close();
      } else {
        this.alertify.error('La disciplina no se ha podido actualizar');
      }
    });
  }
}
